import { U } from "../lib/U.js";
function Uploader(el) {
  let that = this;
  let removeFiles;
  let updateFiles;
  let checkStatus;
  let getFiles;
  let files = [];
  let load;
  let error;
  let progress;
  let addIcon;
  let buttonText = el.buttonText || "Kies bestand";
  let id = el.id || el.name;
  let maxSize = el.maxSize || null;
  let multiple = !!el.multiple;
  let fileCount = 0;
  let allowed = el.allowed || [];
  let input = U.createNewElement("input", ["type=file", "id=" + id]);
  let counter = U.createNewElement("span", ["class=fileCount", "content=0"]);
  let fileContainer = U.createNewElement("div", [
    "class=fileContainer_" + id,
    "aria-hidden=true"
  ]);
  let progressbar = U.createNewElement("div", ["class=progressbar"]);
  let button = U.createNewElement("span", [
    "role=button",
    "class=fileBtn",
    "content=" + (multiple ? `${buttonText}(en)` : buttonText)
  ]);
  let span = U.createNewElement("span", ["content=" + el.label, "class=label"]);
  let docFrag = U.createNewElement("documentFragment");
  let events = {
    load: el.load,
    progress: el.progress,
    abort: el.abort
  };
  let label = U.createNewElement("label", ["class=enhanced"]);
  Object.defineProperties(that, {
    files: {
      get: () => Array.prototype.slice.call(files)
    }
  });
  if (el.name) {
    input.name = el.name;
  }
  if (multiple) {
    input.setAttribute("multiple", true);
    input.name = el.name + "[]";
  }
  if (el.required) {
    U.addClassName(span, "required");
  }
  U.append(label, span, input, button);
  U.append(
    docFrag,
    U.append(
      U.createNewElement("div", ["class=clearfix uploader"]),
      label,
      counter,
      fileContainer,
      progressbar
    )
  );
  removeFiles = function removeFiles(e) {
    e.preventDefault();
    U.removeListener(input, "click", removeFiles);
    input.value = "";
    updateFiles();
  };
  updateFiles = function updateFiles() {
    let files = input.files;
    let text = multiple ? "bestand(en)" : "bestand";
    let hidden = fileContainer.getAttribute("aria-hidden");
    let length = files.length;
    let className;
    let cClass;
    let height;
    button.textContent =
      length > 0
        ? "Verwijder " + (length > 1 ? "bestanden" : "bestand")
        : "Kies " + text;
    counter.textContent = length;
    if (files.length > 0) {
      className = fileContainer.className.replace(/ column_\d{1}/, "");
      cClass = " column_" + (length < 4 ? length : 3);
      fileContainer.className = className + cClass;
      U.addListener(input, "click", removeFiles);
      if (hidden === "true") {
        fileContainer.setAttribute("aria-hidden", false);
        U.animate({
          fn: rate => {
            fileContainer.style.opacity = rate;
            if (rate === 1) {
              fileContainer.style.opacity = 1;
            }
          },
          dur: 0.5
        });
      }
    } else if (hidden === "false") {
      height = fileContainer.clientHeight;
      U.animate(
        {
          fn: rate => (fileContainer.style.opacity = 1 - rate),
          dur: 0.4
        },
        {
          fn: rate => {
            fileContainer.style.padding = 0;
            fileContainer.style.height = height - height * rate + "px";
            if (rate === 1) {
              fileContainer.setAttribute("aria-hidden", true);
              fileContainer.removeAttribute("style");
              fileContainer.innerHTML = "";
            }
          },
          dur: 0.15
        }
      );
    }
  };
  checkStatus = function checkStatus() {
    return fileCount === 0 ? "done" : "loading";
  };
  load = function load(e) {
    fileCount -= 1;
    files.push(e.target.file.data);
    this.status = checkStatus();
    this.uploader = that;
    if (events.load) {
      events.load.call(this, e);
    }
  };
  error = function error(e) {
    fileCount -= 1;
    this.status = checkStatus();
    this.uploader = that;
    if (events.error) {
      events.error.call(this, e);
    }
  };
  progress = function progress(e) {
    if (events.progress) {
      this.uploader = that;
      events.progress.call(this, e);
    }
  };
  addIcon = function addIcon(file, error) {
    let item = U.createNewElement("div", [
      "class=file",
      "data-type=" + file.type
    ]);
    let icon = U.createNewElement("span", ["class=iconFile"]);
    let name = U.createNewElement("span", ["content=" + file.name]);
    if (/image/.test(file.type)) {
      let reader = new FileReader();
      icon.classList.add("image");
      reader.addEventListener(
        "loadend",
        e => (icon.style.backgroundImage = `url(${reader.result})`)
      );
      reader.readAsDataURL(file);
    }
    if (error) {
      item.classList.add("fileError");
    }
    U.append(item, icon, name);
    U.append(fileContainer, item);
  };
  getFiles = function getFiles(e) {
    let files = input.files;
    U.forEach(files, function(file, i) {
      let reader = new window.FileReader();
      let subtype = file.name.substr(file.name.lastIndexOf(".") + 1);
      let type = file.type;
      let error = null;
      U.addListener(reader, "load", load);
      U.addListener(reader, "progress", progress);
      U.addListener(reader, "error", error);
      reader.file = {
        name: file.name,
        size: file.size,
        type: type,
        subtype: subtype,
        data: file
      };
      if (allowed.some(type => subtype.indexOf(type) > -1)) {
        let size = Math.round(file.size / 1000);
        if (maxSize && size > maxSize) {
          error = "SIZE";
        }
      } else {
        error = "TYPE";
      }
      if (!error) {
        fileCount += 1;
        reader.readAsDataURL(file);
      } else {
        reader.status = checkStatus();
        reader.uploader = that;
        events.load.call(reader, { target: reader });
      }
      addIcon(file, error);
    });
    updateFiles();
  };
  U.addListener(input, "change", getFiles);
  return docFrag;
}
export default Uploader;
